'use strict';

var _ = require('lodash');

var UrlUtil = {
  join: function () {
    return _.reduce(arguments, function (url, part) {
      part = part.toString();

      // check to see if it ends with a /
      if (part.lastIndexOf('/') === part.length - 1) {
        return url += part;
      } else {
        return url += part + '/';
      }
    }, '');
  },

  getLocationPattern: function () {
    return '-?\\d{1,2}\\.?\\d+\\,-?\\d{1,3}\\.?\\d+,\\d{1,2}z';
  },

  parseLocationString: function (locstr) {
    var parts = locstr.split(',');

    return {
      lat: parseFloat(parts[0]),
      lng: parseFloat(parts[1]),
      zoom: parseInt(parts[2].slice(0, -1))
    };
  },

  formatLocationToString: function (loc) {
    return [loc.lat, loc.lng, loc.zoom+'z'].join(',');
  }
};

module.exports = UrlUtil;


// WEBPACK FOOTER //
// ./src/common/utils/UrlUtil.js